<div mat-dialog-content>
  <div [innerHtml]="dialogMessage"> </div>
</div>
<div mat-dialog-actions>
  <button mat-raised-button (click)="cancel()">Cancel</button>
  <button mat-raised-button cdkFocusInitial color="accent" (click)="delete()"> Continue </button>
</div>
